import LocalStorage, { Keys } from "../Storage/LocalStorage";

export const isDemoEnabled = () => {
  return hasFeature(FEATURES.DEMO_ENABLED);
};

export const isAllowChartEnabled = () => {
  return hasFeature(FEATURES.ALLOW_CHART);
};

/** Uses the same rules as hasFeature but accepts the roles array from the API (before localStorage). */
export const rolesIncludeFeature = (roles, featureName) => {
  if (!Array.isArray(roles)) {
    return false;
  }
  const target = featureName.toLowerCase();
  return roles.some(
    (role) =>
      Array.isArray(role?.features) &&
      role.features.some((feature) => feature?.name?.toLowerCase() === target)
  );
};

const hasFeature = (featureName) => {
  const roles = LocalStorage.get(Keys.ROLES);
  if (!Array.isArray(roles)) {
    return false;
  }
  const target = featureName.toLowerCase();
  return roles.some(
    (role) =>
      Array.isArray(role?.features) &&
      role.features.some((feature) => feature?.name?.toLowerCase() === target)
  );
};

/**
 * Check if a dataset has DataSelectorAccess permission.
 * @param {object} dataset - The dataset object from the API
 * @returns {boolean} true if dataset has DataSelectorAccess in permissionGroupDatasetFeatureNames
 */
export const hasDatasetSelectorAccess = (dataset) => {
  if (!dataset) {
    return true; // Default to true for null/undefined for backward compatibility
  }
  const rawFeatureNames = dataset?.permissionGroupDatasetFeatureNames;
  let featureNames = rawFeatureNames;

  if (typeof rawFeatureNames === 'string') {
    try {
      featureNames = JSON.parse(rawFeatureNames);
    } catch {
      featureNames = [];
    }
  }

  if (!Array.isArray(featureNames)) {
    return true; // Default to true if not an array for backward compatibility
  }
  return featureNames.some(
    (name) => name?.toLowerCase?.() === 'dataselectoraccess'
  );
};

const FEATURES = {
  DEMO_ENABLED: "DemoEnabled",
  ALLOW_CHART: "AllowChart",
};